import {
  GradientColorStop,
  interpolateGradientColor,
  parseCssColorToRgb,
} from '@app/helpers/interpolate-gradient-color';

/**
 * @deprecated Prefer `GradientColorStop` from `@app/helpers/interpolate-gradient-color`.
 * Kept so stream-quality call sites can keep importing the local module path.
 */
export type { GradientColorStop as MinimapGradientStop };

export { parseCssColorToRgb };

/**
 * Linear RGB blend across sorted stops. Thin alias over the shared interpolator.
 */
export function interpolateMinimapGradientColor(
  successRate: number,
  stops: Array<{ rate: number; color: string }>,
): string {
  return interpolateGradientColor(successRate, stops);
}
